__turbopack_context__.v({
  "buttonRow": "AnchorPairing-module__-Pks7a__buttonRow",
  "buttonRowLabel": "AnchorPairing-module__-Pks7a__buttonRowLabel",
  "card": "AnchorPairing-module__-Pks7a__card",
  "cardBadge": "AnchorPairing-module__-Pks7a__cardBadge",
  "cardHeader": "AnchorPairing-module__-Pks7a__cardHeader",
  "cardLines": "AnchorPairing-module__-Pks7a__cardLines",
  "cardMeta": "AnchorPairing-module__-Pks7a__cardMeta",
  "cardPending": "AnchorPairing-module__-Pks7a__cardPending",
  "cardTitle": "AnchorPairing-module__-Pks7a__cardTitle",
  "cards": "AnchorPairing-module__-Pks7a__cards",
  "controls": "AnchorPairing-module__-Pks7a__controls",
  "detailButton": "AnchorPairing-module__-Pks7a__detailButton",
  "detailButtonSelected": "AnchorPairing-module__-Pks7a__detailButtonSelected",
  "hint": "AnchorPairing-module__-Pks7a__hint",
  "intro": "AnchorPairing-module__-Pks7a__intro",
  "modeBadge": "AnchorPairing-module__-Pks7a__modeBadge",
  "modeLegend": "AnchorPairing-module__-Pks7a__modeLegend",
  "modeOption": "AnchorPairing-module__-Pks7a__modeOption",
  "modePicker": "AnchorPairing-module__-Pks7a__modePicker",
  "outro": "AnchorPairing-module__-Pks7a__outro",
  "root": "AnchorPairing-module__-Pks7a__root",
  "scrollHint": "AnchorPairing-module__-Pks7a__scrollHint",
  "viewport": "AnchorPairing-module__-Pks7a__viewport",
});
